import React, { FC, useState, useEffect } from 'react';
import { SCUIButton, SCUILoading } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb, SCUICustomDataGrid } from '../../atomic/molecules';
import { Grid, Tooltip } from '@mui/material';
import { RefundQuery } from '../../services/query';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import TimeHelper from '../../utils/time';
import { downloadExcel } from '../../utils/excelFileHelper';
import Swal from 'sweetalert2';
import Helper from '../../utils/helper';
import { PetitionPDF } from './PetitionPDF';

export const PetitionRefundList: FC<any> = () => {
    const backofficeUrl = import.meta.env.VITE_APPURL!;
    const { t } = useTranslation();
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [selectedRowsForDownload, setSelectedForDownload] = useState<any[]>([]);
    const [selectedRowsAmount, setSelectedRowsAmount] = useState('');
    const [filterInput, setFilterInput] = useState({ Take: 100, Skip: 0 });
    const [pageSize, setPageSize] = useState(100);
    const [pageNumber, setPageNumber] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pdfDownload, setPdfDownload] = useState<boolean>(false);
    const [datas, setDatas] = useState<any>();
    const [pdfComponent, setPdfComponent] = useState<React.ReactNode | null>(null);
    const columns: ExtendedGridColDef[] = [
        { field: 'refundId', headerName: 'Id' },
        {
            field: 'date',
            headerName: t('general.date'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{TimeHelper.formatDateHour(params.row.date)}</h1>}>
                        <div>{TimeHelper.formatDateHour(params.row.date)}</div>
                    </Tooltip>
                );
            },
        },
        { field: 'accountOwner', headerName: t('general.name'), flex: 1 },

        {
            field: 'customerMail',
            headerName: t('general.eMail'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.customerMail}</h1>}>
                        <div>{params.row.customerMail}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'orderNumber',
            headerName: t('general.orderNo'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.orderNumber}</h1>}>
                        <div>{params.row.orderNumber}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'refundReasonDesc',
            headerName: t('refundList.refundReasonDesc'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.refundReasonDesc}</h1>}>
                        <div>{params.row.refundReasonDesc}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'refundStatusName',
            headerName: t('refund.paymentStatus'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.refundStatusName}</h1>}>
                        <div>{params.row.refundStatusName}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'description',
            headerName: t('general.description'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.description}</h1>}>
                        <div>{params.row.description}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'wireRefundAmount',
            headerName: t('lcwMoney.amount'),
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={
                            <h1>
                                {Helper.formatNumber(params.row.wireRefundAmount)} {import.meta.env.VITE_CURRENCY!}{' '}
                            </h1>
                        }
                    >
                        <div>
                            {Helper.formatNumber(params.row.wireRefundAmount)} {import.meta.env.VITE_CURRENCY!}
                        </div>
                    </Tooltip>
                );
            },
        },

        {
            field: 'edit',
            headerName: ' ',
            flex: 1,
            renderCell: (params) => {
                return (
                    <p
                        className="linktxt"
                        onClick={() => window.open(backofficeUrl + '/Refund/?id=' + params?.row.refundId, '_blank')}
                    >
                        {'Ödeme Detayı'}
                    </p>
                );
            },
        },
    ];

    const CreatePetition = () => {
        const refundIds = selectedRows.map((item) => item.refundId);
        RefundQuery.CreatePetition({ refundIdList: refundIds })
            .then((res: any) => {
                if (res.data.result) {
                    Swal.fire({
                        icon: 'success',
                        title: t('general.completed'),
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    setPdfDownload(true);
                    SearchRefund();
                } else Swal.fire(t('general.failed'), ' ', 'error');
            })
            .finally(() => {
                setPdfDownload(false);
            });
    };

    const downloadExcelHandler = () => {
        const data = [...selectedRowsForDownload];
        if (selectedRowsAmount) {
            const lastRow: any = { ...data[data.length - 1] };
            lastRow.Tutar = selectedRowsAmount;
            data.push(lastRow);
        }
        downloadExcel({
            excelDownloadData: data,
            excelDownloadFolderName: 'PetitionRefundList' + new Date().toJSON().slice(0, 10).replace(/-/g, '_'),
        });
    };

    const handleSelectionModelChange = (model: any[]) => {
        const selectedData = model.map((id: any) => {
            return datas.find((city: any) => city.refundId === id);
        });
        setSelectedForDownload(
            selectedData.map((item: any, index: number) => ({
                No: index + 1,
                Alıcı: item.accountOwner,
                Banka: item.bankName,
                IBAN: item.ibanNumber,
                Tutar: Helper.formatNumber(item.wireRefundAmount) + ' ' + import.meta.env.VITE_CURRENCY!,
            }))
        );
        setSelectedRowsAmount(
            Helper.formatNumber(selectedData.reduce((acc: any, item: any) => acc + item.wireRefundAmount, 0)) +
                ' ' +
                import.meta.env.VITE_CURRENCY!
        );
        setSelectedRows(selectedData);
    };

    const SearchRefund = () => {
        setLoading(true);
        RefundQuery.SearchRefund(filterInput)
            .then((res: any) => {
                if (res.data) {
                    setDatas(res.data.refundList.items);
                    setRowCount(res.data.refundList.pagingInfo.totalCount);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        SearchRefund();
    }, [filterInput]);

    useEffect(() => {
        if (pdfDownload && selectedRowsForDownload) {
            const pdf = <PetitionPDF data={selectedRowsForDownload} amount={selectedRowsAmount} />;
            setPdfComponent(pdf);
        }
    }, [pdfDownload, selectedRowsForDownload]);

    return (
        <SCUIContent>
            <Grid container spacing={1}>
                <SCUIBreadCrumb title={'Dilekçe Oluşturulabilecek Kayıtlar'} componentLink={'PetitionRefundList'} />
                {pdfComponent}
                {selectedRows && selectedRows.length ? (
                    <React.Fragment>
                        <Grid
                            size={{
                                lg: 3,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUIButton
                                text="Dilekçe Oluştur"
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                buttonType="button"
                                onClick={CreatePetition}
                            />
                        </Grid>
                        <Grid
                            size={{
                                lg: 3,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUIButton
                                text="Tablo Oluştur"
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                buttonType="button"
                                onClick={downloadExcelHandler}
                            />
                        </Grid>
                    </React.Fragment>
                ) : (
                    <></>
                )}
                {datas ? (
                    <Grid
                        size={{
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <SCUICustomDataGrid
                            onPageSizeChange={(i: number) => {
                                setFilterInput({ Take: Number(i), Skip: 0 });
                                setPageNumber(0);
                                setPageSize(i);
                            }}
                            page={pageNumber}
                            getRowId={(row: any) => row.refundId}
                            selectionOnClick={true}
                            checkboxSelection
                            rows={datas}
                            columns={columns}
                            onSelectionModelChange={handleSelectionModelChange}
                            selectionModel={selectedRows.map((row) => row.refundId)}
                            loading={loading}
                            rowCount={rowCount}
                            pageSize={pageSize}
                            paginationModeChange
                            onPageChange={(i: number) => {
                                setPageNumber(i);
                                setFilterInput({ ...filterInput, Skip: Number(i) });
                            }}
                        />
                    </Grid>
                ) : (
                    <SCUILoading />
                )}
            </Grid>
        </SCUIContent>
    );
};
